import { Route } from '@angular/router';
import { ERole, verifyRolesGuardFactory } from '@helipagos/auth';
import { HomeLayoutComponent } from './components/home-layout/home-layout.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('@helipagos/auth').then((m) => m.AuthModule),
      },
      {
        canActivate: [verifyRolesGuardFactory(ERole.ROLE_ADMIN)],
        path: 'home',
        loadChildren: () => import('@helipagos/movements').then((m) => m.MovementsModule),
      },
      {
        canActivate: [verifyRolesGuardFactory(ERole.ROLE_ADMIN)],
        path: 'clients',
        loadChildren: () => import('@helipagos/clients').then((m) => m.ClientesModule),
      },
      {
        canActivate: [verifyRolesGuardFactory(ERole.ROLE_ADMIN)],
        path: 'checkout',
        loadChildren: () => import('@helipagos/checkout-router').then((m) => m.CheckoutRouterModule),
      },
      {
        canActivate: [verifyRolesGuardFactory(ERole.ROLE_ADMIN)],
        path: 'configuration',
        loadChildren: () => import('@helipagos/configuration').then((m) => m.ConfigurationModule),
      },
      {
        path: '**',
        redirectTo: 'home',
      },
    ],
  },
];
